export const PAYOUT_FEE_PERCENT = 10;
export const MIN_PAYOUT_CENTS = 2000;

export function calcPayoutFee(grossCents: number): number {
  return Math.round(grossCents * PAYOUT_FEE_PERCENT / 100);
}

export function calcPayoutNet(grossCents: number): number {
  return grossCents - calcPayoutFee(grossCents);
}
